import api from './client'

export interface SipConfig {
  hasConfig: true
  sipUsername: string
  sipPassword: string
  pbxWsUri: string
  pbxHost: string
  displayName: string | null
}

export interface NoConfig { hasConfig: false }

export type CallConfigResult = SipConfig | NoConfig

export interface CallDefaults {
  pbxWsUri: string
  pbxHost: string
}

export const callConfigsApi = {
  getMyConfig: (companyId: string) =>
    api.get<CallConfigResult>(`/companies/${companyId}/me/call-config`),
  getDefaults: (companyId: string) =>
    api.get<CallDefaults | null>(`/companies/${companyId}/call-config/defaults`),
  upsert: (companyId: string, userId: string, dto: {
    extension: string; sipUsername: string; sipPassword?: string
    pbxWsUri: string; pbxHost: string; displayName?: string; isEnabled?: boolean
  }) => api.put(`/companies/${companyId}/users/${userId}/call-config`, dto),
  remove: (companyId: string, userId: string) =>
    api.delete(`/companies/${companyId}/users/${userId}/call-config`),
  getForAdmin: (companyId: string, userId: string) =>
    api.get(`/companies/${companyId}/users/${userId}/call-config`),
}
